import CountryExceptions from './CountryExceptions';

export default CountryExceptions;
